import api from "../src/services/forecastService";
import forecast_api from "../src/services/forecastService";
import moment from "moment";
import { start } from "nprogress";
import { computed } from "vue";
import { mapGetters, mapState, mapActions } from "vuex";
import { EventBus } from "../src/eventBus";
export default {
	data() {
		return {
			currentPage: 1,
			pageSize: 10,
			totalItems: 0,
			moment: moment,
			selected_local_date: null,
			selected_local_store: null,
			approve_forecast_dialog: false,
			pickerOpt: {
				firstDayOfWeek: 1,
				disabledDate(time) {
					// return time.getTime() > Date.now();
				},
			},
			adjusted_trx: null,
			show_by: 'trx',
			selected_basic: 'sales',
			selected_ot: 'all',
			order_type_list: []
		};
	},
	created() {
		const configApiData = JSON.parse(localStorage.getItem('company_config'));
		if(!configApiData || !configApiData.config){
			this.getCompanyConfig();
		}
	},
	computed: {
		...mapState("salesForecastStoreV2", [
			"selected_forecast_date",
			"selected_forecast_start_date",
			"selected_forecast_end_date",
			"selected_forecast_view",
			"selected_view",
			"selected_outlet",
			"failed_page",
			"show_by_view",
			"outlets",
			"payload",
			"tableData",
			"graphData",
			"customDateFormat",
			"weather_data",
			"event_data",
			"planing_data",
			"table_loading",
			"forecast_popup_loading",
			"selected_store_level",
			"set_selected_approve_date",
			"approve_dates_list",
			"selected_store_id",
			"event_categories",
			"forecast_popup_loaded",
			"forecast_approve_data",
			"forecast_approve_data_clone",
			"forecast_graph_data",
			"store_forecast_data",
			"forecast_graph_data_sales",
			"is_forecast_approved",
			"forecast_day_level_data",
			"summary_data",
			"graph_label",
			"forecast_last_update_date",
			"selected_order_type",
			"efficiency_data",
			"old_amount",
			"allow_approve"
		]),
		...mapState("CommonStore", ["companyData"]),
		currency() {
			return this.companyData.currency ? (this.companyData.currency + ' ') : "";
		},
		storeName() {
			return this.outlets.length > 0 ? this.outlets.find(outlet => outlet.id === this.selected_outlet).name : "";
		},
		todayDate() {
			return moment().format("Do MMMM YYYY");
		},
		computedTableData() {
			if(this.planing_data && this.planing_data.results)
				return this.refactorDataForTable(this.planing_data.results, this.efficiency_data);
			else 
				return [];
		},
		computedForecastDayData() {
			if(this.planing_data && this.forecast_day_level_data.results)
				return this.refactorDataForTable(this.forecast_day_level_data.results, this.efficiency_data);
			else 
				return [];
		},
		computedGraphData() {
			let result = [];
			if(this.planing_data && this.planing_data.results){
				for (const key in this.planing_data.results[0]) {
					if (Object.hasOwnProperty.call(this.planing_data.results[0], key)) {
						const element = this.planing_data.results[0][key];
						const label = this.selected_view === 'hour' ?  key.split('to')[0] : moment(key, 'YYYY-MM-DD').format('DD MMM YY, ddd');
						result.push({forecast_week: label, ...element})
					}
				}
				return result;
			}
			else 
				return [];
		},
		formattedDate() {
            return moment(this.selected_forecast_date, 'YYYY-MM-DD').format('Do MMMM YYYY, dddd');
        },
		formattedForecastDate() {
            return moment(this.selected_forecast_date, 'YYYY-MM-DD').format('YYYY-MM-DD');
        },
		formattedDay() {
            return moment(this.selected_forecast_date, 'YYYY-MM-DD').format('dddd');
        },
		computedStoreForecastData() {
            return this.store_forecast_data ? this.store_forecast_data.results : [];
        },
		checkIsApproved(){
            let condition = 0;
            if(this.formattedForecastDate){
                let selected_data = this.computedStoreForecastData.find((i)=>i[this.formattedForecastDate]);
                condition =  selected_data[this.formattedForecastDate].approved;
            }
            return condition;
        },
		checkCompany(){
            let data = JSON.parse(localStorage.getItem('check_company'));
            let obj = {
                        is_sb_malaysia: false,
                        is_kfc: false,
                        is_mcd: false,
                        is_bk: false,
                        is_bkasia: false,
                        is_mcd_north: false,
                        is_demo: false,
                        is_bt: false,
                        is_bb: false,
                        is_dominos: false,
                        is_gf: false,
                        is_sb_india: false,
                    };
            if(!data){
                const get_comp = process.env.VUE_COMPANY_NAME;
                if(get_comp){
                obj[get_comp] = true
                }
                data = obj;
                // console.log(obj, 'process.env.VUE_COMPANY_NAME');
            }
            return data;
        },
		isEditable(){
            // return moment(this.set_selected_approve_date,'YYYY-MM-DD').isSameOrAfter(moment().format('YYYY-MM-DD'));
			const configApiData = JSON.parse(localStorage.getItem('company_config'))
            console.log(configApiData, 'configApiData')
            const enableWithin = configApiData.config.allow_transaction_sales_edit_till_time;
            const enableFrom = configApiData.config.allow_transaction_sales_edit_till_days;
            const today = moment().format('YYYY-MM-DD');
            const currTime = moment().format('HH:mm:ss');
			let selected_ap_condition = null;
			if(enableFrom >= 0) {
                selected_ap_condition = moment(this.set_selected_approve_date, 'YYYY-MM-DD').isSame(moment(today, 'YYYY-MM-DD').add(enableFrom, 'days'));
            } else if(enableFrom < 0) {
                selected_ap_condition = moment(this.set_selected_approve_date, 'YYYY-MM-DD').isSame(moment(today, 'YYYY-MM-DD').subtract(Math.abs(enableFrom), 'days'));
            } 
			console.log(selected_ap_condition, 'selected_ap_condition')
			if(selected_ap_condition) {
				if(enableFrom >= 0) {
					return moment(this.set_selected_approve_date, 'YYYY-MM-DD').isSameOrAfter(moment(today, 'YYYY-MM-DD').add(enableFrom, 'days')) && moment(currTime, 'HH:mm:ss').isSameOrBefore(moment(enableWithin, 'HH:mm:ss'));
				} else if(enableFrom < 0) {
					return moment(this.set_selected_approve_date, 'YYYY-MM-DD').isSameOrAfter(moment(today, 'YYYY-MM-DD').subtract(Math.abs(enableFrom), 'days')) && moment(currTime, 'HH:mm:ss').isSameOrBefore(moment(enableWithin, 'HH:mm:ss'));
				}
			} else {
				if(enableFrom >= 0) {
					return moment(this.set_selected_approve_date, 'YYYY-MM-DD').isSameOrAfter(moment(today, 'YYYY-MM-DD').add(enableFrom, 'days'));
				} else if(enableFrom < 0) {
					return moment(this.set_selected_approve_date, 'YYYY-MM-DD').isSameOrAfter(moment(today, 'YYYY-MM-DD').subtract(Math.abs(enableFrom), 'days'));
				}
			}
            return false;
        }
	},
	watch: {},
	mounted() {
		
	},
	beforeRouteUpdate(to, from, next) {
		console.log("to", to, "from", from);
		// Check if the route has query params
		if (!to.query.view || !to.query.start_date || !to.query.end_date) {
			//  Clear route query params
			this.$store.commit("salesForecastStoreV2/SET_SHOW_BY_VIEW", false);
		} else {
			this.$store.commit("salesForecastStoreV2/SET_SHOW_BY_VIEW", true);
			next();
			this.$forceUpdate();
		}
	},
	methods: {
		...mapActions("salesForecastStoreV2", ["getAllOutletsAction", "callHourLevelApiAction", "callWeekDayLevelApiAction", "loadApproveForecastData", "getForecastStatus"]),
		...mapActions("CommonStore", ["getCompanyConfig"]),
		updateAdjTrx(value) {
            this.adjusted_trx = value;
        },
		updateAdjSales(value) {
            // this.old_amount = value;
        },
		updateApproveDate(date){
            this.set_selected_approve_date = date;
            this.approveForecast(date);
        },
		approveForecast(date, is_forecast_approved = false) {
            this.$store.commit("salesForecastStoreV2/SET_SELECTED_APPROVE_DAT", date)
            this.loadApproveForecastData();
            this.approve_forecast_dialog = true;
			console.log(is_forecast_approved, 'is_forecast_approved')
			this.$store.commit("salesForecastStoreV2/HANDLE_FORECAST_STATUS", is_forecast_approved);
        },
		handleData(data) {
			this.show_by = data;
			if(data === 'trx') {
				this.$store.commit("salesForecastStoreV2/SET_FORECAST_APPROVE_GRAPH_DATA");
			} else {
				this.$store.commit("salesForecastStoreV2/SET_FORECAST_APPROVE_GRAPH_DATA_SALES");
			}
			setTimeout(() => {
				EventBus.$emit('renderDayForecastGraph');
			},500);
		},
		goBackTo() {
			const view = this.selected_view;
			const store_id = localStorage.getItem("store_id");
			const week = localStorage.getItem("week");
			let start_date = null;
			let end_date = null;
			if (view === "week") {
				this.$router.push('/schedule-planner').catch(() => { });
			} else if (view === "day" || view === "hour") {
				const path = view === "day" ? "week" : view === "hour" ? "day" : "";
				start_date = this.getWeekDates(this.selected_forecast_date).start_date;
				end_date = this.getWeekDates(this.selected_forecast_date).end_date;
				// if(view === "day") {
				// 	start_date = this.getWeekDates(week).start_date;
				// 	end_date = this.getWeekDates(week).end_date;
				// } else if(view === "hour") {
				// 	start_date = this.getWeekDates(this.selected_forecast_date).start_date;
				// 	end_date = this.getWeekDates(this.selected_forecast_date).end_date;
				// }
				this.handleStoreChange(store_id, { start_date, end_date }, path)
				this.$router.push({ query: { view: path, start_date, end_date } }).catch(() => { });
			}
		},
		callApproveForecast() {
			this.$store.commit("salesForecastStoreV2/HANDLE_FORECAST_LOADING", true);
            let payload = {
                "date": this.set_selected_approve_date,
                "old_forecast": this.forecast_approve_data.forecast.sales,
                "new_forecast": parseInt(this.forecast_approve_data.forecast.adjusted_quantity),
                "approve": true,
                "outlet": this.selected_outlet
            };
			if(this.checkCompany.is_bt) {
				const amount = (this.old_amount === null || this.old_amount ==='') ? 0 : this.old_amount;
				payload.sales_updated =  !(this.forecast_approve_data_clone.forecast.adjusted_quantity != this.forecast_approve_data.forecast.adjusted_quantity);
				payload.old_sales = this.forecast_approve_data.forecast.amount;
				payload.new_sales = parseFloat(this.forecast_approve_data.forecast.adjusted_amount);
			}
            forecast_api.approveForecast(payload).then((res)=>{
				// Need to load the data again
				console.log(this.payload, 'this.payload')
				this.callWeekDayLevelApiAction(this.payload);
                // this.loadStoreDataAction({ outlet: [this.selected_store_id], name: this.selected_store_level });
                this.loadApproveForecastData();
                this.$store.commit("salesForecastStoreV2/HANDLE_FORECAST_LOADING", false);
                this.approve_forecast_dialog = false;

				this.$notify({
					type: "success",
					title: "Success",
					text: "Forecast approved"
				});
            }).catch((err)=>{
                this.$store.commit("salesForecastStoreV2/HANDLE_FORECAST_LOADING", false);
				this.$notify({
					type: "error",
					title: "Error",
					text: "Something went wrong!"
				});
                console.error(err);
            });
        },
		getOrderTypeList() {
            forecast_api.getOrderType().then((res)=>{
				 this.order_type_list = JSON.parse(res.data);
				 this.order_type_list.unshift('all');
            }).catch((err)=>{
                this.$store.commit("salesForecastStoreV2/HANDLE_FORECAST_LOADING", true);
                console.error(err);
            });
        },
		switchToView(to) {
			const store_id = localStorage.getItem("store_id");
			const start_date = to === 'hour' ? moment(this.selected_forecast_date).format('YYYY-MM-DD') : this.getWeekDates(this.selected_forecast_date).start_date;
			const end_date = to === 'hour' ? moment(this.selected_forecast_date).format('YYYY-MM-DD') : this.getWeekDates(this.selected_forecast_date).end_date;
			this.handleStoreChange(store_id, { start_date, end_date }, to);
			this.$router.push({ query: { view: to, start_date, end_date } }).catch(() => { });
			this.selected_local_date = this.selected_forecast_date;
			this.selected_local_store = this.selected_outlet;
		},
		handleViewChange(selected_basic) {
			this.selected_ot = 'all';
			this.$store.commit("salesForecastStoreV2/SET_ORDER_TYPE", this.selected_ot);
			this.$store.commit("salesForecastStoreV2/SET_BASICS", selected_basic);
			EventBus.$emit('changeBasic', selected_basic);
			const view = this.$route.query.view;
			const store_id = localStorage.getItem("store_id");
			const start_date = this.getWeekDates(this.selected_forecast_date).start_date;
			const end_date = this.getWeekDates(this.selected_forecast_date).end_date;
			if(view === 'hour') {
				this.handleStoreChange(store_id, { start_date: start_date, end_date: start_date }, view);
			} else {
				this.handleStoreChange(store_id, { start_date, end_date }, view);
			}
			this.$router.push({ query: { view, start_date, end_date } }).catch(() => { });
			this.selected_local_date = this.selected_forecast_date;
			this.selected_local_store = this.selected_outlet;
		},
		handleOTChange(selected_ot) {
			this.$store.commit("salesForecastStoreV2/SET_ORDER_TYPE", selected_ot);
			const view = this.$route.query.view;
			const store_id = localStorage.getItem("store_id");
			const start_date = this.getWeekDates(this.selected_forecast_date).start_date;
			const end_date = this.getWeekDates(this.selected_forecast_date).end_date;
			if(view === 'hour') {
				this.handleStoreChange(store_id, { start_date: start_date, end_date: start_date }, view);
			} else {
				this.handleStoreChange(store_id, { start_date, end_date }, view);
			}
			this.$router.push({ query: { view, start_date, end_date } }).catch(() => { });
			this.selected_local_date = this.selected_forecast_date;
			this.selected_local_store = this.selected_outlet;
		},
		getWeekDates(week) {
			const date = moment(week, "YYYY-MM-DD");
			const start_date = date.clone().startOf('isoWeek').format('YYYY-MM-DD'); // Start of current week (Monday)
			const end_date = date.clone().endOf('isoWeek').format('YYYY-MM-DD'); // End of current week (Sunday)
			console.log("start_date", start_date, "end_date", end_date);
			return { start_date, end_date };
		},
		handleStoreChange(store_id, date, view) {

			if(view === 'hour') {
				// Check is forecast approved or not and set into this.is_forecast_approved
				const sel_data = this.computedForecastDayData.find((i)=> i.forecast_week === date.start_date);
				// console.log("this.computedTableData", sel_data, date.start_date, this.computedForecastDayData);
				this.$store.commit("salesForecastStoreV2/HANDLE_FORECAST_STATUS", sel_data ? sel_data.approved : false);
			}


			// console.log("date.start_date", date.start_date, "date.end_date", date.end_date, "view", view);
			this.$store.commit("salesForecastStoreV2/SET_SELECTED_VIEW", view);
			this.$store.commit("salesForecastStoreV2/SET_SELECTED_OUTLET", store_id);
			this.$store.commit("salesForecastStoreV2/SET_SELECTED_FORECAST_START_DATE", date.start_date);
			this.$store.commit("salesForecastStoreV2/SET_SELECTED_FORECAST_END_DATE", date.end_date);
			// this.selected_local_date = new Date(date.start_date);
			// console.log("selected_local_date", this.selected_local_date);
			this.$store.commit(
				"salesForecastStoreV2/SET_SELECTED_FORECAST_DATE",
				new Date(date.start_date)
			);
			this.$store.commit("salesForecastStoreV2/SET_PAYLOAD", {
				view: view,
				start_date: date.start_date,
				end_date: date.end_date,
				outlet: store_id
			});

			if (view === "day") {
				this.$store.commit("salesForecastStoreV2/SET_CUSTOM_DATE_FORMAT", `${moment(date.start_date, 'YYYY-MM-DD').format('DD-MM-YYYY')} To ${moment(date.end_date, 'YYYY-MM-DD').format('DD-MM-YYYY')}`);
				console.log(view, 'VIEW', `${date.start_date} To ${date.end_date}`, this.customDateFormat);
				this.callWeekDayLevelApiAction({outlet: store_id, start_date: date.start_date, end_date: date.end_date, view});
			} else if (view === "hour") {
				this.$store.commit("salesForecastStoreV2/SET_CUSTOM_DATE_FORMAT", `${moment(date.start_date, 'YYYY-MM-DD').format('DD-MM-YYYY')}`);
				// Call required API
				this.callHourLevelApiAction({store_id, date:date.start_date});
			} else if(view === "week") {
				this.$store.commit("salesForecastStoreV2/SET_CUSTOM_DATE_FORMAT", `${moment(date.start_date, 'YYYY-MM-DD').format('DD-MM-YYYY')} To ${moment(date.end_date, 'YYYY-MM-DD').format('DD-MM-YYYY')}`);
				console.log('week level api')
				this.callWeekDayLevelApiAction({outlet: store_id, start_date: date.start_date, end_date: date.end_date, view});
			}
			this.$forceUpdate();
		},
		handleDateChange(event) {
			console.log(event, 'event');
			const store_id = localStorage.getItem("store_id");
			let start_date = null;
			let end_date = null;
			if(this.selected_view === 'day'|| this.selected_view === 'week') {
				start_date = this.getWeekDates(event).start_date;
				end_date = this.getWeekDates(event).end_date;
			} else if(this.selected_view === 'hour') {
				start_date = moment(event).format('YYYY-MM-DD');
				end_date = moment(event).format('YYYY-MM-DD');
			}
			this.handleStoreChange(store_id, { start_date, end_date }, this.selected_view);
			this.$router.push({ query: { view: this.selected_view, start_date, end_date } }).catch(() => { });
		},
		handleOutletChange(event) {
			const store_id = this.selected_local_store;
			localStorage.setItem("store_id", store_id);
			localStorage.setItem("store", store_id);
			let start_date = null;
			let end_date = null;
			if(this.selected_view === 'day' || this.selected_view === 'week') {
				start_date = this.getWeekDates(this.selected_forecast_date).start_date;
				end_date = this.getWeekDates(this.selected_forecast_date).end_date;
			} else if(this.selected_view === 'hour') {
				start_date = moment(this.selected_forecast_date).format('YYYY-MM-DD');
				end_date = moment(this.selected_forecast_date).format('YYYY-MM-DD');
			}
			this.handleStoreChange(store_id, { start_date, end_date }, this.selected_view);
			this.$router.push({ query: { view: this.selected_view, start_date, end_date } }).catch(() => { });
		},
		handleDateClick(view, date) {
			if (!view || !date) { this.failed_page = true; return };
			const start_date = view === "day" ? moment(date.split("to")[0], "Do MMM YYYY").format("YYYY-MM-DD") : date;
			const end_date = view === "day" ? moment(date.split("to")[1], "Do MMM YYYY").format("YYYY-MM-DD") : date;
			const store_id = localStorage.getItem("store_id");
			// If date is valid then proceed else show error notification
			if (!start_date || !end_date) {
				this.failed_page = true;
				this.$notify({
					type: "error",
					title: "Error",
					text: "Invalid date selected"
				});
				return;
			}
			// Navigate to the new route
			if (this.$route.params.view !== view || this.$route.params.date !== date) {
				this.$router.push({ query: { view, start_date: start_date, end_date } }).catch(() => { });
				this.handleStoreChange(store_id, { start_date, end_date }, view);
			}
		},
		handleCurrentChange(page) {
			this.currentPage = page;
			this.fetchDataFromServer();
		},
		callHourLevelApi(store_id, date) {
			api.forecastQueryDetail({ outlet: store_id, date }).then(response => {
				this.$store.commit("salesForecastStoreV2/SET_TABLE_DATA", response.data);
			}).catch(error => {
				console.error('Error fetching data:', error);
			});
		},
		refactorDataForTable(originalData, efficiencyData) {
			let data = Object.entries(originalData[0]).map(([timeRange, data]) => ({
				forecast_week: timeRange,
				...data
			  }));
			//   Add the efficiency data
			if(efficiencyData) {
				Object.entries(efficiencyData.data).map(([timeRange, elm]) => {
					data.forEach((e, index) => {
						e.efficiency_data = {efficiency: '-', outlier: '-'};
					})
				});
				Object.entries(efficiencyData.data).map(([timeRange, elm]) => {
					data.forEach((e, index) => {
						let condition = timeRange === e.forecast_week;
						// let condition = this.selected_view === 'hour' ? 
						// timeRange.split('to')[0] === e.forecast_week.split('to')[0] || timeRange.split('to')[1] === e.forecast_week.split('to')[1]
						// : timeRange === e.forecast_week;
						// console.log(timeRange.split('to')[0], e.forecast_week.split('to')[0],condition, 'timeRange')
						if(condition) {
							e.efficiency_data = elm;
						}
					})
				});
			}
			  return data;
		},
		refactorDatForGraph(originalData) {
			return Object.entries(originalData[0]).map(([timeRange, data]) => ({
				forecast_week: timeRange,
				...data
			  }));
		},
		weatherIconClass(code) {
            return `http://openweathermap.org/img/w/${code}.png`;
        },
	}
};
